
























































































































import Vue from 'vue'
import PCampoDeFormulario from 'src/typescript/common/PCampoDeFormulario'
import SobreQuemSeraObservado from './SobreQuemSeraObservado'
import NotificacaoVia from './NotificacaoVia'
import CategoriaDePermissao from './CategoriaDePermissao'
import TipoObservado from './TipoObservado'
import EventosObservados from './EventosObservados'
import UsuariosNotificados from './UsuariosNotificados'
import SliderAtivacao from 'src/typescript/common/SliderAtivacao'
import PFormulario from 'src/typescript/common/PFormulario'

import {RegraDeNotificacao, RegraDeNotificacaoInexistente, RegraDeNotificacaoInvalida} from '@/classes/RegrasDeNotificacao'

import {
  DRegraDeNotificacao
} from 'src/tipos'

interface Data {
  carregando: boolean;
  formularioEstaValido: boolean;
  regra: DRegraDeNotificacao;
  camposDeRegrasEditados: Record<string, boolean>;
}

interface Methods {
  pegarRegraParaEdicao: () => Promise<RegraDeNotificacao | undefined>;
  setarCamposSeEhRotaDeEdicao: () => Promise<void>;
  salvarRegra: () => Promise<void>;
  editarRegra: (regraParaEditar: DRegraDeNotificacao) => Promise<void>;
  redirecionarParaTelaDeListagem: () => void;
  inicializarFormulario: () => Promise<void>;
}

interface Computed {
  legendaBotaoSalvar: string;
  formularioNaoEstaValido: boolean;
  ehRotaDeEdicao: boolean;
  regraFoiCarregada: boolean;
  tipoFoiSelecionado: boolean;
  ehGestorEditando: boolean;
  ehGestorEditandoAPropriaRegra: boolean;
  possuiPermissaoEditarUsuariosNotificados: boolean;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  name: 'RegrasDeNotificaoFormulario',

  components: {
    PCampoDeFormulario,
    SobreQuemSeraObservado,
    TipoObservado,
    SliderAtivacao,
    PFormulario,
    EventosObservados,
    NotificacaoVia,
    UsuariosNotificados,
    CategoriaDePermissao
  },

  computed: {
    legendaBotaoSalvar (): string {
      return this.ehRotaDeEdicao ? 'editar' : 'salvar'
    },

    formularioNaoEstaValido (): boolean {
      return !this.formularioEstaValido
    },

    ehRotaDeEdicao (): boolean {
      const possuiId = !!this.$route.params.id
      return possuiId
    },

    regraFoiCarregada (): boolean {
      return this.regra && !this.carregando
    },

    tipoFoiSelecionado (): boolean {
      return !!this.regra.tipoNotificado
    },

    ehGestorEditando (): boolean {
      const { roleGroup: permissao } = this.$store.state.userInfo
      const usuarioLogadoEhGestor = permissao.kind === 'group'
      return !!this.ehRotaDeEdicao && usuarioLogadoEhGestor
    },

    ehGestorEditandoAPropriaRegra (): boolean {
      const { id: idUsuarioLogado } = this.$store.state.userInfo
      return this.ehGestorEditando && this.regra?.usuariosNotificados?.includes(idUsuarioLogado)
    },

    possuiPermissaoEditarUsuariosNotificados (): boolean {
      return this.$hasPermission({module: 'notificationrules', action: 'post'})
    }
  },

  data () {
    const regra = {...new RegraDeNotificacao()} as DRegraDeNotificacao
    return {
      carregando: true,
      formularioEstaValido: false,
      camposDeRegrasEditados: {} as Record<string, boolean>,
      regra,
      validacoes: RegraDeNotificacao.validacoes
    }
  },

  async mounted (): Promise<void> {
    this.inicializarFormulario()
  },

  methods: {
    async inicializarFormulario (): Promise<void> {
      try {
        this.carregando = true
        await this.setarCamposSeEhRotaDeEdicao()
      } catch (erro) {
        if (erro instanceof RegraDeNotificacaoInexistente) {
          await this.$modalDeErro(erro.message)
        }
      } finally {
        this.carregando = false
      }
    },

    async salvarRegra (): Promise<void> {
      try {
        this.carregando = true
        const regrasDeNotificacao = RegraDeNotificacao.criarRegraParaCadaNotificado(this.regra)
        if (this.ehRotaDeEdicao && regrasDeNotificacao) {
          await this.editarRegra(regrasDeNotificacao[0])
          await this.$modalDeSucesso('Regra editada com sucesso!')
        } else {
          await this.$API.regrasDeNotificacao.save({ regrasDeNotificacao })
          await this.$modalDeSucesso('Regra criada com sucesso!')
        }
        this.carregando = false

        this.redirecionarParaTelaDeListagem()
      } catch (erro) {
        console.log(erro)
        if (erro instanceof RegraDeNotificacaoInvalida) {
          await this.$modalDeErro(erro.message)
        } else {
          await this.$modalDeErro(erro.body.error)
        }
      } finally {
        this.carregando = false
      }
    },

    async editarRegra (regraParaEditar: DRegraDeNotificacao): Promise<void> {
      await this.$API.httpResource.patch({url: `regras-de-notificacao/${this.$route.params.id}`, body: {...regraParaEditar}})
    },

    async setarCamposSeEhRotaDeEdicao (): Promise<void> {
      if (!this.ehRotaDeEdicao) return
      const regraParaEdicao = await this.pegarRegraParaEdicao()
      if (typeof regraParaEdicao === 'undefined') {
        throw new RegraDeNotificacaoInexistente()
      }
      this.regra = {...regraParaEdicao}
    },

    redirecionarParaTelaDeListagem (): void {
      this.$router.push({name: 'regrasDeNotificacao.listagem'})
    },

    async pegarRegraParaEdicao (): Promise<RegraDeNotificacao | undefined> {
      const {id: idDaRegra} = this.$route.params

      const regraValidaOuRedirecionarPraListagem = (regra: RegraDeNotificacao): RegraDeNotificacao | undefined => {
        try {
          console.log(RegraDeNotificacao.from(regra))
          return RegraDeNotificacao.from(regra)
        } catch (erro) {
          if (erro instanceof RegraDeNotificacaoInvalida) {
            this.redirecionarParaTelaDeListagem()
          } else {
            // sentry.captureError(erro)
          }
        }
      }

      const pegarRegraDaStore = (): RegraDeNotificacao | undefined => {
        function tentarEncontrarRegraNosItensCarregados (regra: RegraDeNotificacao): boolean {
          return idDaRegra === regra.id
        }
        const regra = this.$store.state.regrasDeNotificacao.items.find(tentarEncontrarRegraNosItensCarregados)
        return regraValidaOuRedirecionarPraListagem(regra)
      }

      const pegarRegraFazendoRequisicao = async (): Promise<RegraDeNotificacao | undefined> => {
        const resposta = await this.$API.regrasDeNotificacao.get({id: idDaRegra})
        const respostaSucesso = resposta.data?.success
        if (respostaSucesso && Array.isArray(respostaSucesso)) {
          const [regra] = respostaSucesso
          return regraValidaOuRedirecionarPraListagem(regra)
        }
      }
      return pegarRegraDaStore() || pegarRegraFazendoRequisicao()
    }
  }
})
